import { render, staticRenderFns } from "./FaqDetails.vue?vue&type=template&id=b80db9c0"
import script from "./FaqDetails.vue?vue&type=script&lang=js"
export * from "./FaqDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports